/**
 * Brand mark: dark rounded square + gradient "O" ring + gold ascending arrow.
 * Matches the favicon so brand identity stays consistent everywhere.
 */
export default function LogoMark({ size = 32, className = "" }) {
  const px = `${size}px`;
  return (
    <span
      aria-hidden
      className={`inline-grid place-items-center ${className}`}
      style={{ width: px, height: px }}
    >
      <svg viewBox="0 0 64 64" width={size} height={size}>
        <defs>
          <linearGradient id="lm-ring" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#085041" />
            <stop offset="100%" stopColor="#2EC48A" />
          </linearGradient>
          <linearGradient id="lm-sheen" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0a2d25" />
            <stop offset="100%" stopColor="#06231D" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="url(#lm-sheen)" />
        <rect x="0.5" y="0.5" width="63" height="63" rx="13.5" fill="none" stroke="#ffffff" strokeOpacity="0.05" />
        <circle cx="32" cy="32" r="18" fill="none" stroke="url(#lm-ring)" strokeWidth="5.5" />
        <path d="M25 39 L39 25" stroke="#C9A84C" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M31 25 L39 25 L39 33" stroke="#C9A84C" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    </span>
  );
}
